var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgESportsIndustry(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.986 12.648h-1.07v-1.071a.938.938 0 00-1.876 0v1.07H7.97a.937.937 0 100 1.876h1.07v1.07a.937.937 0 101.876 0v-1.07h1.07a.937.937 0 100-1.875zM22.965 11.577a.938.938 0 11-1.875 0 .938.938 0 011.875 0zM20.957 13.585a.938.938 0 11-1.875 0 .938.938 0 011.875 0zM22.965 15.594a.938.938 0 11-1.875 0 .938.938 0 011.875 0zM24.974 13.585a.938.938 0 11-1.875 0 .938.938 0 011.875 0z",
    fill: "#ADC6FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.896 20.72l-2.145-9.116c-.62-2.64-3.019-4.981-6.287-4.981H8.542c-3.447 0-5.71 2.525-6.288 4.98L.11 20.72c-.583 2.478 1.298 4.849 3.84 4.849a3.11 3.11 0 002.655-1.504l1.652-2.754a1.58 1.58 0 011.35-.763H22.4c.55 0 1.066.292 1.349.764l1.651 2.753a3.112 3.112 0 002.657 1.504c2.545 0 4.421-2.376 3.84-4.849zm-3.84 2.974c-.427 0-.829-.228-1.048-.594l-1.652-2.753a3.464 3.464 0 00-2.956-1.674H9.606a3.464 3.464 0 00-2.956 1.674L4.997 23.1c-.219.365-.62.593-1.048.593a2.071 2.071 0 01-2.014-2.545l2.144-9.116a4.568 4.568 0 014.463-3.535h14.922a4.567 4.567 0 014.463 3.535l2.145 9.116a2.071 2.071 0 01-2.017 2.545z",
    fill: "#ADC6FF"
  })));
}

export default __webpack_public_path__ + "./fonts/eSports-industry.562962b601cf0284b8cccbbe1c584d53.svg";
export { SvgESportsIndustry as ReactComponent };